import { isPlainDatatype } from '../../../datatype/Datatype.ts';
import { createConditionOperator } from '../IConditionOperator.ts';
import {
  getComparableNumbers,
  shouldCompareAsNumber,
} from '../utils/numericConditionCoerce.ts';

export const ConditionOperatorNotEqualsType = createConditionOperator({
  code: 'notEquals',
  label: '≠',
  description: 'Diverso da',
  args: [{ type: 'referenceValue' }],
  allowsField: field => isPlainDatatype(field.type),
  compare(value: any, [target]: [any], scope, field) {
    if (value == null && target == null) return false;
    if (shouldCompareAsNumber(field, value, target)) {
      const numbers = getComparableNumbers(value, target);
      // Se non parsabili, ricadiamo sul confronto letterale originale
      return numbers
        ? !numbers.numericValue.equals(numbers.numericTarget)
        : value !== target;
    }
    return value !== target;
  },
});
